module.exports = __webpack_public_path__ + "static/media/flying-high-promo.931b547d.png";